// extracted by mini-css-extract-plugin
module.exports = {"cartIcon":"add_to_cart_cartIcon__GDFpd"};